//
//
//
//
//
//
//
//
//
//
//
//

import { BUTTON_SIZE_LARGE, BUTTON_SIZE_MEDIUM } from '../../utils/constants'
import DTButton from '../DTButton/DTButton.vue'
export default {
  components: { DTButton },
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: BUTTON_SIZE_MEDIUM,
      validator: (value) => {
        return [BUTTON_SIZE_MEDIUM, BUTTON_SIZE_LARGE].includes(value)
      },
    },
  },
  computed: {
    buttonSize() {
      switch (this.size) {
        case BUTTON_SIZE_MEDIUM:
        default:
          return 'tw-w-8 tw-h-8'
        case BUTTON_SIZE_LARGE:
          return 'tw-w-10 tw-h-10'
      }
    },
  },
}
